import { defineComponent as _defineComponent } from 'vue'
import { daysOfWeek, weeksInMonth } from '@busy-human/k9-library';
import { computed, ref, watch } from 'vue';
import moment from "moment";

type Props = {
	singleSelect?: boolean
}

type Emits = {
	(e: 'selectEvent', eventId: string): void
	(e: 'update:dropOffTime', dropOffTime: string | null): void
	(e: 'update:pickUpTime', pickUpTime: string | null): void
}

const THIRTY = 30;
const SEVENTEEN = 17;


export default /*@__PURE__*/_defineComponent({
  __name: 'calendar-picker',
  props: {
    singleSelect: { type: Boolean }
  },
  emits: ["selectEvent", "update:dropOffTime", "update:pickUpTime"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const Days = [
	'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];
const Months = [
	'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
];

// -- Constants 
const timeframe = ref<{month: number, year: number}>({
	month: new Date().getMonth(),
	year: new Date().getFullYear()
});

// -- Ref
const dropOffDate = ref<Date | null>(null);
const pickUpDate = ref<Date | null>(null);

const dropOffTime = ref<Date | null>(null);
const pickUpTime = ref<Date | null>(null);

// -- Computed
const eventWeeks = computed(() => {
	const weekCount = weeksInMonth(timeframe.value.year, timeframe.value.month);

	return Array(weekCount).fill(null).map(() => []);;
});

const availableDropOffTimes = computed(() => {
	if(!dropOffDate.value)
	{return [];}
    
	const dropOffTimes: Date[] = [];

	for(let i = moment(dropOffDate.value).set({hour: 9}); i.hour() < SEVENTEEN; i.add(THIRTY, 'minutes')){
		dropOffTimes.push(i.toDate());
	}

	return dropOffTimes;
});

const availablePickUpTimes = computed(() => {
	if(!pickUpDate.value)
	{return [];}
    
	const pickUpTimes: Date[] = [];

	for(let i = moment(pickUpDate.value).set({hour: 9}); i.hour() < SEVENTEEN; i.add(THIRTY, 'minutes')){
		pickUpTimes.push(i.toDate());
	}
	return pickUpTimes;
});

// -- user intraction
const adjustMonth = (delta = 1) => {
	const tmp = new Date(timeframe.value.year, timeframe.value.month + delta, 1);
	timeframe.value = { year: tmp.getFullYear(), month: tmp.getMonth() };
};

const selectDate = (date: Date) => {
	if(props.singleSelect){
		if(dropOffDate.value && date.valueOf() === dropOffDate.value.valueOf()){
			dropOffDate.value = null;
			dropOffTime.value = null;
		}else{
			dropOffDate.value = date;
			dropOffTime.value = null;
		}
	}else if(pickUpDate.value && date.valueOf() === pickUpDate.value.valueOf()){
		pickUpDate.value = null;
		pickUpTime.value = null;
	}else if(dropOffDate.value && date.valueOf() === dropOffDate.value.valueOf()){
		dropOffDate.value = null;
		dropOffTime.value = null;
	}else if(dropOffDate.value && date.valueOf() > dropOffDate.value.valueOf()){
		pickUpDate.value = date;
		pickUpTime.value = null;
	}else{
		dropOffDate.value = date;
		dropOffTime.value = null;
	}
};

watch(dropOffTime, (val:Date | null) => {
	if(val)
	{emit('update:dropOffTime', val.toISOString());}
});

watch(pickUpTime, (val:Date | null) => {
	if(val)
	{emit('update:pickUpTime', val.toISOString());}
});

// -- Helpers
const formatDate = (date: Date) => moment(date).format('MMM D');

const formatTime = (date: Date) => moment(date).format('hh:mm A');

const __returned__ = { props, emit, Days, Months, timeframe, dropOffDate, pickUpDate, dropOffTime, pickUpTime, eventWeeks, THIRTY, SEVENTEEN, availableDropOffTimes, availablePickUpTimes, adjustMonth, selectDate, formatDate, formatTime, get daysOfWeek() { return daysOfWeek }, get weeksInMonth() { return weeksInMonth }, computed, ref, watch, get moment() { return moment } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})